var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClassicIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.00012207L0 6.50012H6.5V0.00012207Z",
    fill: "#0079DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.50012L6.5 13.0001V6.50012H0Z",
    fill: "#1366C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.50012H13L6.5 0.00012207V6.50012Z",
    fill: "#238CFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13.0001L13 6.50012H6.5V13.0001Z",
    fill: "#1C6EB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassicIcon);
export default __webpack_public_path__ + "static/media/classic_icon.f349109cc0b6b70e3486c332158990e9.svg";
export { ForwardRef as ReactComponent };